<template>
  <v-card flat class="my-0">
    <v-card-text>
    <form @submit.prevent novalidate>
      <v-text-field
        v-model="field.mask"
        v-bind:label="$t('Mask')"
      ></v-text-field>
      <v-text-field
        v-model="defaultValue"
        type="number"
        v-bind:label="$t('DefaultValue')"
        @change="applyDefaultValueRestrictions"
      ></v-text-field>
      <v-text-field
        v-model="field.minVal"
        type="number"
        v-bind:label="$t('MinValue')"
        v-bind:max="field.maxVal"
        v-bind:min="NUMERIC_MIN_VALUE"
        :error-messages="minLengthErrors"
        @change="applyMinValueRestrictions"
      ></v-text-field>
      <v-text-field
        v-model="field.maxVal"
        type="number"
        v-bind:label="$t('MaxValue')"
        v-bind:max="NUMERIC_MAX_VALUE"
        v-bind:min="field.minVal"
        :error-messages="maxLengthErrors"
        @change="applyMaxValueRestrictions"
      ></v-text-field>
      <v-text-field
        v-model="field.scale"
        type="number"
        v-bind:label="$t('Decimals')"
        :error-messages="scaleErrors"
        @change="applyDefaultValueRestrictions"
        min="0"
        v-bind:max="NUMERIC_MAX_SCALE"
      ></v-text-field>
    </form>
    </v-card-text>
  </v-card>
</template>

  <script>
import { maxValue, minValue, } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { NUMERIC_MAX_VALUE, NUMERIC_MAX_SCALE, NUMERIC_MIN_VALUE } from '@/ecm/common/Constants';
import Utils from '@/ecm/common/Utils';

export default {
    props: {
        field: {
            type: Object,
            default: () => ({}),
        },
        validator: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            NUMERIC_MAX_VALUE: NUMERIC_MAX_VALUE,
            NUMERIC_MAX_SCALE: NUMERIC_MAX_SCALE,
            NUMERIC_MIN_VALUE: NUMERIC_MIN_VALUE
        };
    },
    mixins: [validationMixin],
    validations: {
        field: {
            scale: {
                maxValue: maxValue(NUMERIC_MAX_SCALE),
                minValue: minValue(0),
            },
            maxVal: {
                maxValue: Utils.validators.numericFieldMaxValue,
                minValue: minValue(NUMERIC_MIN_VALUE)
            },
            minVal: {
                maxValue: maxValue(NUMERIC_MAX_VALUE),
                minValue: minValue(NUMERIC_MIN_VALUE)
            }
        },
    },
    computed: {
        defaultValue: {
            get: function () {
                var userDecSep = this.$store.getters['account/user'].MetricDecimalSep;
                var userThouSep = this.$store.getters['account/user'].MetricThousandSep;

                return this.field.default
                    .replaceAll(userThouSep, '')
                    .replaceAll(userDecSep, '.');
            },
            set: function (newValue) {
                var userDecSep = this.$store.getters['account/user'].MetricDecimalSep;
                this.field.default = newValue.replaceAll('.', userDecSep);
            }
        },
        scaleErrors() {
            const errors = [];
            if (this.field.scale > NUMERIC_MAX_SCALE || this.field.scale < 0) {
                errors.push(this.$t('MaxMinValueDecimal'));
            }
            return errors;
        },
        maxLengthErrors() {
            const errors = [];

            if (!this.validator.field.maxVal.maxValue)
                errors.push(`${this.$t('MaxValue')}: ${NUMERIC_MAX_VALUE}`);
            if (!this.validator.field.maxVal.minValue)
                errors.push(`${this.$t('MinValue')}: ${NUMERIC_MIN_VALUE}`);

            return errors;
        },
        minLengthErrors() {
            const errors = [];

            if (!this.validator.field.minVal.maxValue)
                errors.push(`${this.$t('MaxValue')}: ${NUMERIC_MAX_VALUE}`);
            if (!this.validator.field.minVal.minValue)
                errors.push(`${this.$t('MinValue')}: ${NUMERIC_MIN_VALUE}`);

            return errors;
        },
    },
    methods: {
        applyMinValueRestrictions() {
            if (this.field.minVal > this.field.maxVal) {
                this.field.minVal = this.field.maxVal;
            }
            this.applyDefaultValueRestrictions();
        },
        applyMaxValueRestrictions() {
            if (this.field.maxVal < this.field.minVal) {
                this.field.maxVal = this.field.minVal;
            }
            this.applyDefaultValueRestrictions();
        },
        applyDefaultValueRestrictions() {
            if (this.field.minVal && !this.$v.field.scale.$invalid) {
                const minValue = parseFloat(this.field.minVal);
                this.field.minVal = minValue.toFixed(0).toString();
            }

            if (this.field.maxVal && !this.$v.field.scale.$invalid) {
                const maxValue = parseFloat(this.field.maxVal);
                this.field.maxVal = maxValue.toFixed(0).toString();
            }

            if (!this.defaultValue) {
                return;
            }

            var number = parseFloat(this.defaultValue);
            if (
                (this.field.maxVal || this.field.maxVal == 0) &&
                number > parseFloat(this.field.maxVal)
            ) {
                number = parseFloat(this.field.maxVal);
            }
            if (
                (this.field.minVal || this.field.minVal == 0) &&
                number < parseFloat(this.field.minVal)
            ) {
                number = parseFloat(this.field.minVal);
            }

            this.defaultValue = number.toFixed(this.field.scale || 0);
        }
    },
};
</script>
